import React, { Component } from "react";
import { Footer } from "./common/footerbar";
import { HomeItem } from "./home/item";
import * as fun from '../components/common';
import imgURL from '../res/images/logo.png';
export default class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: this.props.selectedTab || "Contract",
            visible: false
        };      
    }
    componentDidMount()
    {
       fun.wxshare(global.constants.wx_tijian+this.props.match.url,'全人·健康服务运营商','体检预约、报告查询、基因检测、防癌早查、健康管理服务解决方案。',imgURL);
    }
 
    render() {
        return (           
            <div className='home'>
                <HomeItem />
                <Footer />
            </div>
        );
    }
}
